import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { TableCell, Typography } from '@material-ui/core'

import { MyRowProps } from '../../../types/tableTypes'
import { subscriptionStatusNames } from '../../../types/subscriptionStatusNames'

import { UserModel } from '../../../server/mpsklad_core/Models/UserModel'
import { SubscriptionStatus } from '../../../server/mpsklad_core/Entity/Enums/SubscriptionStatus'

export const SubscriptionStatusCell =
  observer(({row}: MyRowProps<UserModel>) => {
    const classes = useStyles()

    const statusClasses: {
      readonly [K in SubscriptionStatus]: string
    } = {
      [SubscriptionStatus.NotSubscribed]: classes.statusNotSubscribed,
      [SubscriptionStatus.Active]: classes.statusActive,
      [SubscriptionStatus.Expired]: classes.statusExpired
    }

    return (
      <TableCell className={clsx('table-border', classes.cell)}>
        <Typography variant="body2" className={clsx(classes.statusText, statusClasses[row.subscriptionStatus])}>
          {subscriptionStatusNames[row.subscriptionStatus]}
        </Typography>
      </TableCell>
    )
  })

const useStyles =
  makeStyles(({palette, shape, spacing}) => ({
      cell: {
        width: 120,
        border: 'none',
        verticalAlign: 'middle'
      },
      statusText: {
        fontWeight: 500,
        padding: spacing(0.5, 1),
        borderRadius: shape.borderRadius,
        display: 'inline-block',
        textAlign: 'center'
      },
      statusActive: {
        color: palette.success.dark
      },
      statusNotSubscribed: {
        color: palette.warning.dark
      },
      statusExpired: {
        color: palette.error.dark
      }
    }
  ))